// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_i-0";
export var colorSwatch = "_i-5";
export var compactSwatch = "_i-7";
export var fillWidth = "_i-4";
export var iconButton = "_i-2";
export var iconWrapper = "_i-3";
export var shadow = "_i-6";
export var xs = "_i-1";